/** @format */

import React, { Component } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import I18 from '../Translate/I18n';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import '../../assets/themes/OPL/css/react-date-time.css';
import Moment from 'moment';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

require('moment/locale/pl');

class TimePickerForm extends Component {
    componentDidMount() {
        if (!this.props.defaultValue) {
            this.props.callback(new Moment());
        }
    }

    render() {
        const {
            classes,
            defaultValue,
            isValidDate,
            callback,
            helpText,
            error,
            success,
            id,
            dateFormat,
            fieldName,
            fullWidth,
            timeformat,
            autoComplete,
        } = this.props;

        let { placeholder } = this.props;

        const helpTextClasses = classNames({
            [classes.labelRootError]: error,
            [classes.labelRootSuccess]: success && !error,
            [classes.labelRootPadding]: true,
            [classes.labelRootColor]: true,
        });

        const rdtClasses = classNames({
            [classes.label]: true,
            [classes.datePicker]: true,
        });

        let overrideDefaultValue;

        if (defaultValue) {
            overrideDefaultValue = defaultValue;
        } else {
            overrideDefaultValue = new Date();
        }

        if (!placeholder) {
            placeholder = 'HH:MM';
        }

        return (
            <FormControl id={'reactDateTime'} classes={{ label: classes.label }} className={rdtClasses} fullWidth={fullWidth || true}>
                <Datetime
                    locale="pl"
                    {...this.props}
                    defaultValue={overrideDefaultValue}
                    isValidDate={isValidDate}
                    dateFormat={false}
                    timeFormat={timeformat}
                    onChange={(moment) => callback(moment, fieldName)}
                    inputProps={{
                        id: fieldName,
                        placeholder: placeholder,
                        autoComplete: autoComplete,
                        className: classes.datePickerInput,
                    }}
                />
                {helpText !== undefined ? (
                    <FormHelperText id={id + '-text'} className={helpTextClasses}>
                        <I18 trans={helpText} />
                    </FormHelperText>
                ) : null}
            </FormControl>
        );
    }
}

TimePickerForm.propTypes = {
    callback: PropTypes.func.isRequired,
    helpText: PropTypes.string,
    dateFormat: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isValidDate: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    error: PropTypes.bool,
    success: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fieldName: PropTypes.string,
    fullWidth: PropTypes.bool,
    autoComplete: PropTypes.string,
    timeFormat: PropTypes.bool,
};

export default withStyles(oplAppStyle)(TimePickerForm);
